export enum Role {
    CONSIGNOR = 'consignor',
    CONSIGNEE = 'consignee',
    CARRIER = 'carrier',
    FRACHTFUEHRER = 'frachtfuehrer',
    REMOTECARRIER = 'remote_carrier',
    REMOTECONSIGNEE = 'remote_consignee',
    REMOTECONSIGNOR = 'remote_consignor',
}
